import { useCallback, useEffect } from "react";
import { checkMessageOrigin } from "../utils/general";
import { useNavigate } from "react-router-dom";
import { DASHBOARDS, encodeDashboardName } from "../lib/context/DashboardProvider";

const useSpacefanaRedirect = () => {
    const navigate = useNavigate();

    const handleNavigation = useCallback((path, search) => {
        navigate({
            pathname: path,
            search: search
        });
    }, [navigate]);

    const handleRequest = useCallback((msg) => {
        if(!msg.page) return;

        let pathname;
        if(msg.page.toLowerCase() === "space cockpit") {
            pathname = "/spacecockpit";
        }
        else {
            const index = DASHBOARDS.findIndex((d) => d.toLowerCase() === msg.page.toLowerCase());
            if(index < 0) return;
            pathname = "/dashboards/" + encodeDashboardName(DASHBOARDS[index]);
        }
        
        handleNavigation(pathname, msg.search ?? "");
    }, [handleNavigation]);

    useEffect(() => {
        const handleMessage = (e) => {
            let msg = e.data;

            if(msg?.type === "spacefana-page-request") {
                console.log(msg);
                if(!checkMessageOrigin(e)) return;
                handleRequest(msg);
            }
        };

        // on mount
        window.addEventListener('message', handleMessage);

        return () => {
            // on unmount
            window.removeEventListener('message', handleMessage); 
        }
    }, [handleRequest]);
};

export default useSpacefanaRedirect;